/* eslint-disable typescript-sort-keys/string-enum */

// Keep in this order
enum CampaignDashboardTab {
  Updates = "Updates",
  SupporterList = "Supporter list",
  Edit = "Edit",
  Settings = "Settings",
}

export default CampaignDashboardTab;
